import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import player4 from '../../../assets/player4.png';
import hero from '../../../assets/hero.png';
import lapun from '../../../assets/lapun.svg';
import splitApple from '../../../assets/split-apple.png';
import player5 from '../../../assets/player5.png';
import splitOrange from '../../../assets/split-orange.png'
import player6 from '../../../assets/player6.png';
import splitPizza from '../../../assets/split-pizza.png';
import player7 from '../../../assets/player7.png';
import kruglik from '../../../assets/kruglik.svg';
import fishik from '../../../assets/fishik.svg';
import kulbabka from '../../../assets/kulbabka.svg';
import splitChocolate from '../../../assets/split-chocolate.png';

import '../../../styles/FractionStoryScreen.css';
import useScrollUnlock from '../../../hooks/useScrollUnlock';

export default function Comics2({ onCheckStateChange }) {
  const rootRef = useScrollUnlock(onCheckStateChange);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div ref={rootRef} className="fraction-story-screen quiz-screen fractions-comics-2">
        <div className="fraction-story quiz-card">
            <div className="fraction-story-container">
                <p className="comics-title">Комікс <br/> Частина 2</p>
                <p className="paper-note">Ділимо на рівні частини</p>

                <p className="fraction-story-go-down">Гортай униз, щоб прочитати комікс</p>
                <svg className="fraction-story-go-down-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_95_1660" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
                    <rect width="40" height="40" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_95_1660)">
                    <path d="M19.8492 25.9062L25.6408 20.1253L24.1825 18.667L20.8963 21.9532V14.0782H18.7863V21.9532L15.5 18.667L14.0417 20.1253L19.8492 25.9062ZM19.8363 35.8337C17.6576 35.8337 15.6067 35.4181 13.6833 34.587C11.76 33.7559 10.081 32.6234 8.64625 31.1895C7.21181 29.7553 6.07875 28.077 5.24708 26.1545C4.41569 24.232 4 22.1816 4 20.0032C4 17.8132 4.41556 15.7548 5.24667 13.8278C6.07778 11.9009 7.21028 10.2248 8.64417 8.79949C10.0783 7.37421 11.7567 6.24574 13.6792 5.41408C15.6017 4.58269 17.6521 4.16699 19.8304 4.16699C22.0204 4.16699 24.0789 4.58255 26.0058 5.41366C27.9328 6.24477 29.6089 7.37269 31.0342 8.79741C32.4594 10.2221 33.5879 11.8975 34.4196 13.8237C35.251 15.7498 35.6667 17.8077 35.6667 19.9974C35.6667 22.176 35.2511 24.227 34.42 26.1503C33.5889 28.0737 32.461 29.7527 31.0363 31.1874C29.6115 32.6219 27.9361 33.7549 26.01 34.5866C24.0839 35.418 22.026 35.8337 19.8363 35.8337ZM19.8333 33.7395C23.6608 33.7395 26.9076 32.4037 29.5738 29.732C32.2396 27.0603 33.5725 23.8164 33.5725 20.0003C33.5725 16.1728 32.2396 12.926 29.5738 10.2599C26.9076 7.59407 23.6608 6.26116 19.8333 6.26116C16.0172 6.26116 12.7733 7.59407 10.1017 10.2599C7.43 12.926 6.09417 16.1728 6.09417 20.0003C6.09417 23.8164 7.43 27.0603 10.1017 29.732C12.7733 32.4037 16.0172 33.7395 19.8333 33.7395Z" fill="#1E1E1E"/>
                    </g>
                </svg>
            </div>
            <div className="fraction-story-pink-bg">
                <img className="fraction-story-hero" src={hero} alt=""/>
                <div className="fraction-story-pink-rectangle">
                {/* example 1 */}
                    <div className="comics-note-wrapper">
                        <div className="comics-note">
                            <span className="comics-dots">
                                <span></span>
                                <span></span>
                            </span>
                            <span className="text">Приклад 1</span>
                        </div>
                    </div>
                    <p className="fraction-story-pink-rec-text">Лапун розрізав яблуко на</p>
                    <motion.p
                        className="comics-big-number"
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ 
                            duration: 0.6,
                            ease: "easeOut"
                        }}
                        >
                        2
                    </motion.p>
                    <p className="fraction-story-pink-rec-text">рівні частини</p>

                    <img className="comics-img" src={player4} alt=""/>

                    <motion.div 
                        className="fraction-story-heroes"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}    
                    >
                        <div className="fraction-story-hero">
                            <p className="thought-bubble right">
                                Половинка яблука — це одна друга, або  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn> 1</mn></mrow><mrow><mn>2</mn></mrow></mfrac></math>
                            </p>
                            <img src={lapun} alt=""/>
                        </div>
                    </motion.div>
                    <img className="comics-img" src={splitApple} alt=""/>

                    {/* example 2 */}
                    <div className="comics-note-wrapper">
                        <div className="comics-note">
                            <span className="comics-dots">
                                <span></span>
                                <span></span>
                            </span>
                            <span className="text">Приклад 2</span>
                        </div>
                    </div>
                    <p className="fraction-story-pink-rec-text">Круглик поділив апельсин на</p>
                    <motion.p
                        className="comics-big-number"
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ 
                            duration: 0.6,
                            ease: "easeOut"
                        }}
                        >
                        3
                    </motion.p>
                    <p className="fraction-story-pink-rec-text">рівні частини</p>
                    <img className="comics-img" src={player5} alt=""/>
                    <motion.div 
                        className="fraction-story-heroes"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}    
                    >
                        <div className="fraction-story-hero">
                             <img src={kruglik} alt="" />
                            <p className="thought-bubble">
                                Я візьму третину апельсина. Це одна третя, або  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn> 1</mn></mrow><mrow><mn>3</mn></mrow></mfrac></math>
                            </p>
                        </div>
                    </motion.div>
                    <img className="comics-img" src={splitOrange} alt=""/>

                    {/* example 3 */}
                    <div className="comics-note-wrapper">
                        <div className="comics-note">
                            <span className="comics-dots">
                                <span></span>
                                <span></span>
                            </span>
                            <span className="text">Приклад 3</span>
                        </div>
                    </div>
                    <p className="fraction-story-pink-rec-text">Фішик розрізав піцу на</p>
                    <motion.p
                        className="comics-big-number"
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ 
                            duration: 0.6,
                            ease: "easeOut"
                        }}
                        >
                        4
                    </motion.p>
                    <p className="fraction-story-pink-rec-text">рівні шматки</p>
                    <img className="comics-img" src={player6} alt=""/>
                    <motion.div 
                        className="fraction-story-heroes"
                        initial={{ x: 100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                    >
                        <div className="fraction-story-hero">
                            <p className="thought-bubble right">
                                Я з’їм 1 шматок піци. Це одна четверта, або  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn> 1</mn></mrow><mrow><mn>4</mn></mrow></mfrac></math>
                            </p>
                            <img src={fishik} alt="" />
                        </div>
                    </motion.div>
                    <img className="comics-img" src={splitPizza} alt=""/>


                    {/* example 4 */}
                    <div className="comics-note-wrapper">
                        <div className="comics-note">
                            <span className="comics-dots">
                                <span></span>
                                <span></span>
                            </span>
                            <span className="text">Приклад 4</span>
                        </div>
                    </div>
                    <p className="fraction-story-pink-rec-text">Кульбабка має шоколадку, яку легко розділити на</p>
                    <motion.p
                        className="comics-big-number"
                        initial={{ scale: 0 }}
                        whileInView={{ scale: 1 }}
                        viewport={{ once: true }}
                        transition={{ 
                            duration: 0.6,
                            ease: "easeOut"
                        }}
                        >
                        10
                    </motion.p>
                    <p className="fraction-story-pink-rec-text">рівних частин</p>
                    <img className="comics-img" src={player7} alt=""/>
                    <motion.div 
                        className="fraction-story-heroes"
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: true, amount: 0.3 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}    
                    >
                        <div className="fraction-story-hero">
                             <img src={kulbabka} alt="" />
                            <p className="thought-bubble">
                                Мені потрібно 7 шматочків шоколадки, щоб вистачило на всіх. Це сім десятих, або  <math xmlns="http://www.w3.org/1998/Math/MathML"><mfrac><mrow><mn> 7</mn></mrow><mrow><mn>10</mn></mrow></mfrac></math>
                            </p>
                        </div>
                    </motion.div>
                    <img className="comics-img" src={splitChocolate} alt=""/>

                
              </div>
            </div>            
        </div>
    </div>
  );
}
